import React from 'react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DevicesIcon from '@mui/icons-material/Devices';
import HubIcon from '@mui/icons-material/Hub';
import SectionHeading from './SectionHeading';
import CardGrid from './CardGrid';
import { brandColors } from '../theme';
import { fillCard, cardBody, cardTitle, cardDescription, iconBox } from '../styles/alignedCards';

const services = [
  {
    title: 'Datos e inteligencia',
    description:
      'Convertimos información dispersa en indicadores claros para decidir más rápido y con menos incertidumbre.',
    icon: <InsightsIcon fontSize="large" />,
  },
  {
    title: 'Automatización',
    description:
      'Eliminamos trabajo manual repetitivo en operaciones, reportes y flujos internos para liberar a tu equipo.',
    icon: <AutoFixHighIcon fontSize="large" />,
  },
  {
    title: 'Software a medida',
    description:
      'Construimos herramientas y plataformas adaptadas a cómo opera tu negocio — no plantillas genéricas.',
    icon: <DevicesIcon fontSize="large" />,
  },
  {
    title: 'Integraciones',
    description:
      'Conectamos sistemas, APIs y fuentes de datos para que todo fluya en un solo lugar.',
    icon: <HubIcon fontSize="large" />,
  },
];

const Services = () => (
  <Box component="section" id="services" sx={{ py: { xs: 6, md: 8 } }}>
    <Container maxWidth="lg">
      <SectionHeading
        label="Qué hacemos"
        title="Soluciones tecnológicas para empresas"
        subtitle="Desde la idea hasta la implementación: tecnología que se traduce en eficiencia y valor de negocio."
      />
      <CardGrid columns={{ xs: 1, sm: 2 }} gap={{ xs: 2, sm: 3 }}>
        {services.map((service) => (
          <Card
            key={service.title}
            elevation={0}
            sx={{
              ...fillCard(),
              border: `1px solid ${brandColors.mist}`,
              transition: 'transform 0.25s ease, box-shadow 0.25s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 12px 32px rgba(11, 20, 38, 0.1)',
              },
            }}
          >
            <CardContent sx={cardBody}>
              <Box sx={iconBox}>{service.icon}</Box>
              <Typography variant="h6" component="h3" sx={cardTitle}>
                {service.title}
              </Typography>
              <Typography variant="body2" sx={cardDescription}>
                {service.description}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </CardGrid>
    </Container>
  </Box>
);

export default Services;
